import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { SortDirective } from './sort.directive';

@Directive({
  selector: '[appSortBy]',
  standalone: true})
export class SortByDirective implements OnInit, OnDestroy {
  @Input('appSortBy') sortBy: string;

  private subscription: Subscription;

  constructor(private sort: SortDirective, private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.el.nativeElement.classList.add('sortable');
    this.renderState();
    this.subscription = this.sort.sortChange.subscribe(() => this.renderState());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  @HostListener('click')
  onClick(): void {
    if (this.sortBy) {
      this.sort.sort(this.sortBy);
    }
  }

  private renderState(): void {
    const active = !!this.sortBy && this.sort.predicate === this.sortBy;
    this.el.nativeElement.classList.toggle('sorted', active);

    const icon = this.el.nativeElement.querySelector('i.fa');
    if (!icon) {
      return;
    }
    icon.classList.remove('fa-sort', 'fa-sort-asc', 'fa-sort-desc');
    if (active) {
      icon.classList.add(this.sort.ascending ? 'fa-sort-asc' : 'fa-sort-desc');
    } else {
      icon.classList.add('fa-sort');
    }
  }
}
